import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useState, useEffect } from 'react';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogCustom({
  title = '',
  children,
  isOpen,
  iconBtn: Icon,
  nameBtnConfirm = 'ACEPTAR',
  nameBtnConfirmSecondary = 'ALTA',
  nameBtnCancelar = 'CANCELAR',
  hideActions = false,
  hideConfirm = false,
  transition = false,
  isCentrarBtn = false,
  visibleBtnSecondary = false,
  className = '',
  disabledBtnConfirm = false,
  sx = {},
  handleConfirm,
  handleConfirmSecondary,
  handleConfirmIconBtn,
  onClose,
}) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isOpen || false);
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);
    onClose(false);
  };

  return (
    <Dialog
      sx={sx}
      open={open}
      {...(transition ? { TransitionComponent: Transition } : {})}
      onClose={handleClose}
      className={`${className} dialog-result noSelect`}
    >
      {title && (
        <DialogTitle
          fontSize={15}
          sx={{
            background: '#902421',
            color: '#fff',
            height: '12px',
            lineHeight: '5px',
            mb: 2,
          }}
        >
          {title}
        </DialogTitle>
      )}
      <DialogContent sx={{ padding: 1, width: '100%' }}>
        {children}
      </DialogContent>
      <DialogActions
        sx={
          isCentrarBtn
            ? { display: 'flex', justifyContent: 'center' }
            : undefined
        }
      >
        {!hideActions && (
          <>
            <Button onClick={handleClose}>{nameBtnCancelar}</Button>
            {visibleBtnSecondary && (
              <Button onClick={handleConfirmSecondary} variant="contained">
                {nameBtnConfirmSecondary}
              </Button>
            )}
            {Icon && (
              <Button
                onClick={handleConfirmIconBtn}
                variant="contained"
                sx={{ minWidth: 40, width: 40 }}
              >
                <Icon sx={{ width: 20 }} />
              </Button>
            )}
            {!hideConfirm && (
              <Button
                onClick={handleConfirm}
                variant="contained"
                disabled={disabledBtnConfirm}
              >
                {nameBtnConfirm}
              </Button>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
